import { Typography } from "@cakemail-org/ui-components-v2"
import { TAPIDateRangeReturn } from "../../types/dates"
import { useTranslation } from "react-i18next"

export function LastXDays({ apiTimeRange, addPreviousText = false, removeLastX = false }: { apiTimeRange: TAPIDateRangeReturn, addPreviousText?: boolean, removeLastX?: boolean }) {
    const { t } = useTranslation()
    return <>
        {!removeLastX &&
            <Typography variant="body1L" className="bold" color="shade450.main">
                {apiTimeRange.rangeFormat === "range" ?
                    apiTimeRange.timeAgo :
                    t(`general-last-x-${apiTimeRange.rangeFormat}`, { count: Number(apiTimeRange.timeAgo) })
                }
            </Typography>
        }
        &nbsp;
        {addPreviousText &&
            <Typography variant="body1S" color="silver.main">
                {apiTimeRange.rangeFormat === "range" ? apiTimeRange.timeAgo : t(`email-vs-comparison-${apiTimeRange.rangeFormat}`, { count: Number(apiTimeRange.timeAgo) })}
            </Typography>
        }
    </>
}